/**
 * React adapter entry point
 * Maintains backward compatibility with existing imports
 */

export * from "./store";
export * from "./hooks";
export * from "./StoreProvider";

// Re-export commonly used items from slices and interfaces
export * from "../../interfaces/auth.interface";
export * from "../../interfaces/fpr.interface";
export * from "../../interfaces/language.interface";
export * from "../../selectors";
export {
  setLoginStatus,
  setLeadStatus,
  setIsCommonSsoModalVisible,
  setSsoRedirectUrl,
} from "../../slices/auth.slice";
export {
  setActiveStage,
  setFeedbackState,
  setFprApiData,
  setFprError,
  clearFprError,
  setShouldRefetch,
  setCprPdpCmsData,
  setCprCheckPageCmsData,
  setFprCmsStatus,
  showFprLoader,
  hideFprLoader,
  resetFprState,
  setCustomerType,
  setFprAccessToken,
} from "../../slices/fpr.slice";
export { setLanguage } from "../../slices/language.slice";
